import { createFileRoute } from '@tanstack/react-router';

import { ProjectOrderPage } from '@/areas/orders/ProjectOrder/ProjectOrderPage';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/projects/$projectId/order/')({
    staticData: { access: { permissions: ['create:order'] }, chrome: 'project' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <ProjectOrderPage {...pathParams} />;
}
